// get today's date without time
export const getToday = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

// convert to the date only value (This is used to compare dates without time)
export const convertToDate = (datetimeString) => {
    const datetime = new Date(datetimeString);
    datetime.setHours(0, 0, 0, 0);
    return datetime;
};

export const formatDate = (datetime) => {
    const date = new Date(datetime);
    if (isValidDate(date)) {
      return date.toLocaleDateString('ja-JP');
    }
    return '';
};

export const addMonths = (dateTime, months) => {
    const date = new Date(dateTime);
    date.setMonth(date.getMonth() + months);
    return date;
};

export const isValidDate = (datetime) => {
    const test = datetime.getTime();
    return !isNaN(test);
};